import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { usePUR2040_R01Store } from "./Store_PUR2040_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PUR2040_R01 } from "./Content_PUR2040_R01";
import { SearchSection_PUR2040_R01 } from "./SearchSection_PUR2040_R01";
import { Table_PUR2040_R01 } from "./Table_PUR2040_R01";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { GridRowData } from "./Dto_PUR2040_R01";

export const Container_PUR2040_R01 = () => {
    const { initData } = usePUR2040_R01Store();
    const { setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<GridRowData>>(null);

    const {
        fetchData,
        handleExcelClick,
    } = Content_PUR2040_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined}
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
            />
            <SearchSection_PUR2040_R01 />
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    <Table_PUR2040_R01 gridRef={gridRef} />
                </div>
            </div>
            <Message />
        </div>
    );
};
